import { Box, FormHelperText, Typography } from '@mui/material'
import React, { useState } from 'react'
import Dropzone from 'react-dropzone'
import { Controller, useFormContext } from 'react-hook-form'
import { useUpload } from '../../hooks/useUpload'
import { ConfirmationDialog } from '../ConfirmationDialog/ConfirmationDialog'

export const ControlledDropzone = ({
  name,
  defaultValue = '',
  label,
  helperText,
  height = 180
}) => {
  const { control, formState, clearErrors } = useFormContext()
  const [file, setFile] = useState(control._defaultValues[name])
  const { mutate: upload, isLoading } = useUpload()
  const [open, setOpen] = useState(false)

  return (
    <>
      {label && (
        <Typography component='p' variant='caption'>
          {label}
        </Typography>
      )}
      <Box>
        <Controller
          name={name}
          control={control}
          defaultValue={defaultValue}
          render={({ field: { onChange } }) => {
            const handleChange = async acceptedFiles => {
              clearErrors(name)
              upload(acceptedFiles[0], {
                onSuccess: res => {
                  if (res && res.data) {
                    setFile(res.data.Location)
                    onChange(res.data.Location)
                  }
                },
                onError: error => {
                  const message = error?.message?.errorMessage
                  const errorObj = error?.error
                  if (
                    message === 'File too large' ||
                    error?.code === 413 ||
                    errorObj !== undefined
                  ) {
                    setOpen(true)
                  }
                }
              })
            }

            return (
              <>
                <Dropzone
                  disabled={isLoading}
                  onDrop={handleChange}
                  multiple={false}
                  accept={{
                    'image/png': ['.png'],
                    'image/jpeg': ['.jpeg', '.jpg'],
                    'image/gif': ['.gif']
                  }}
                >
                  {({ getRootProps, getInputProps }) => (
                    <>
                      <Box
                        component='div'
                        {...getRootProps()}
                        sx={{
                          border:
                            file === undefined
                              ? `1px dashed ${
                                  formState.errors[name]?.message !== undefined
                                    ? '#d32f2f'
                                    : '#ccc'
                                }`
                              : `1px solid ${
                                  formState.errors[name]?.message !== undefined
                                    ? '#d32f2f'
                                    : 'transparent'
                                }`,
                          width: '100%',
                          height: height,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        <input {...getInputProps()} />
                        {file !== undefined && !isLoading ? (
                          <img
                            src={file}
                            style={{
                              display: 'block',
                              objectFit: 'cover',
                              width: '100%',
                              height: '100%'
                            }}
                          />
                        ) : (
                          <>
                            <Typography
                              variant='caption'
                              textAlign='center'
                              sx={{ padding: 1 }}
                            >
                              {isLoading
                                ? 'Uploading...'
                                : 'Drag and drop some files here, or click to select files'}
                            </Typography>
                          </>
                        )}
                      </Box>
                    </>
                  )}
                </Dropzone>
              </>
            )
          }}
        />
        {helperText !== undefined && formState.errors[name] === undefined && (
          <FormHelperText id={`helper-text-${name}`}>
            {helperText}
          </FormHelperText>
        )}
        {formState.errors[name]?.message !== undefined && (
          <FormHelperText
            id={`error-helper-text-${name}`}
            error
            style={{ textAlign: 'right', paddingRight: 8 }}
          >
            {formState.errors[name]?.message}
          </FormHelperText>
        )}
      </Box>
      <ConfirmationDialog
        open={open}
        handleClose={() => setOpen(false)}
        handleConfirm={() => setOpen(false)}
        agreeText='Ok'
        title='File is too large'
        content={
          <Typography variant='body1' align='center'>
            Max file size is 2MB
          </Typography>
        }
      />
    </>
  )
}
